import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=63dc83b0&scoped=true"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js"
import style0 from "./ErrorBoundary.vue?vue&type=style&index=0&id=63dc83b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc83b0",
  null
  
)

export default component.exports